/* eslint-disable*/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import store from './store'


Vue.prototype.$http = axios;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')


window.jivo_onLoadCallback = () => {
  console.log('Widget fully loaded, esperando jdiv...');
  setTimeout(() => {
    const jdivElements = document.getElementsByTagName('jdiv');
    console.log('jdivElements:', jdivElements);
    const jivoTarget = jdivElements[1];
    if (jivoTarget) {
      store.dispatch('updateJivoElements', jivoTarget);
      jivoTarget.style.display = 'none';
      console.log('Jivo ocultado');
    } else {
      console.log('No se encontró el jdiv a ocultar');
    }
    store.commit('setWidget', true);
  }, 700); // ajusta el tiempo según necesidad
};


window.jivo_onClose = () => {
  jivo_api.open()
  const jivoElement1 = store.getters['jivoElement1'];
  if (jivoElement1 ) {
    jivoElement1.style.display = 'none';
  }
  store.state.jivo_modal_flag = false;
}
window.jivo_onOpen = () => {
  const jivoElement1 = store.getters['jivoElement1'];
  if (jivoElement1 ) {
    jivoElement1.style.display = 'block';
  }

}
window.jivo_onMessageReceived = () => {
	console.log(`Check agents messages`);
  store.state.message_recived = true;
}